import { getCurrentUser, fetchAuthSession, signOut } from 'aws-amplify/auth';

/**
 * Service to handle authentication operations
 */
export const authService = {
  /**
   * Get the current access token
   */
  async getAccessToken(): Promise<string | null> {
    try {
      const session = await fetchAuthSession();
      const accessToken = session.tokens?.accessToken;
      return accessToken ? accessToken.toString() : null;
    } catch (error) {
      console.error('Failed to get access token:', error);
      return null;
    }
  },

  /**
   * Refresh the authentication token
   */
  async refreshToken(): Promise<string | null> {
    try {
      const session = await fetchAuthSession({ forceRefresh: true });
      const accessToken = session.tokens?.accessToken;
      return accessToken ? accessToken.toString() : null;
    } catch (error) {
      console.error('Failed to refresh token:', error);
      throw error;
    }
  },

  /**
   * Check if user is authenticated
   */
  async isAuthenticated(): Promise<boolean> {
    try {
      await getCurrentUser();
      return true;
    } catch {
      return false;
    }
  },

  /**
   * Sign out the current user
   */
  async signOut(): Promise<void> {
    try {
      await signOut();
    } catch (error) {
      console.error('Failed to sign out:', error);
      throw error;
    }
  },
};
